// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cd478f19","453":"ebede418","732":"84bf69f6"}[chunkId] + ".chunk.js";
};